import { LandersNewHomesModel } from "./../models/landers_newhomesandconstruction";

(function (LANDERS_NEWHOMES) {

  var init = function () {
    LANDERS_NEWHOMES.model = new LandersNewHomesModel(defaultCriteriaOptions());
  };

  var defaultCriteriaOptions = function () {
    return {
      location: MOVE.SearchHelper.getRecentSearchedLocation(MOVE.CONSTANTS.DEFAULT_LANDING_PAGE_LOCATION),
      property_status: MOVE.CONSTANTS.PROPERTY_STATUS.forSale
    };
  };

  LANDERS_NEWHOMES.LandingPage = {
    init: init
  };
})(MOVE.LANDERS_NEWHOMES);
MOVE.LANDERS_NEWHOMES.LandingPage.init();



// WEBPACK FOOTER //
// ./landers_newhomesandconstruction/controllers/landers_newhomesandconstruction.js